import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

const baseURL = process.env.REACT_APP_API_URL ?? '';
axios.defaults.baseURL = baseURL;

const mock = new MockAdapter(axios, { delayResponse: 2000 });

export default mock;
